import { COMMENTS_FETCH_REQUEST, COMMENTS_FETCH_SUCCESS, COMMENTS_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    comments: {},
    error: ''
}

const comments = (state = initialState, action) => {
    switch (action.type) {
        case COMMENTS_FETCH_REQUEST:
            return {
                loading: true,
                comments: {},
                error: '',
            }
        case COMMENTS_FETCH_SUCCESS:
            return {
                loading: false,
                comments: action.payload,
                error: ''
            }
        case COMMENTS_FETCH_FAILURE:
            return {
                loading: false,
                comments: {},
                error: action.payload
            }
        default: return state
    }
}

export default comments;